import { colorMappedProps } from 'style-utils/withStyledProps/withColorProps';
import { mapScales } from './mapScales';
import { positiveOrNegative } from './positiveOrNegative';
import { backgroundxMappedProps } from 'style-utils/withStyledProps/withBackgroundProps';

export const scales = mapScales(colorMappedProps, backgroundxMappedProps);

export const transforms = [
  'margin',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
  'top',
  'bottom',
  'left',
  'right',
].reduce(
  (acc, curr) => ({
    ...acc,
    [curr]: positiveOrNegative,
  }),
  {},
);
